const getStatusBadgeClasses = (currentstatus) => {
  const status = Number(currentstatus);
  switch (status) {
    case 0:
      return 'bg-amber-50 text-amber-700';
    case 1:
      return 'bg-sky-50 text-sky-700';
    case 2:
      return 'bg-emerald-50 text-emerald-700';
    case 3:
      return 'bg-blue-50 text-blue-700';
    case 4:
      return 'bg-purple-50 text-purple-700';
    default:
      return 'bg-gray-50 text-gray-700';
  }
};
const getStatusText = (currentstatus) => {
  const status = Number(currentstatus);
  switch (status) {
    case 0:
      return 'Pending';
    case 1:
      return 'In Progress';
    case 2:
      return 'Completed';
    case 3:
      return 'Re-Opened';
    case 4:
      return 'New';
    default:
      return 'Pending';
  }
};

const getStatusDotClasses = (currentstatus) => {
  const status = Number(currentstatus);
  switch (status) {
    case 0:
      return 'bg-amber-500 ring-amber-100';
    case 1:
      return 'bg-sky-500 ring-sky-100';
    case 2:
      return 'bg-emerald-500 ring-emerald-100';
    case 3:
      return 'bg-blue-500 ring-blue-100';
    case 4:
      return 'bg-purple-500 ring-purple-100';
    default:
      return 'bg-gray-400 ring-gray-100';
  }
};


export default function ServiceLogsPopup ({ isOpen, onClose, logs, isLoading, serviceName, userName }) {
  if (!isOpen) return null;

  // If a "New" (status 4) log exists, hide any auto-generated "Status changed"
  // In Progress (status 1) entries — these are created by the backend before our
  // workaround sets the status to 4, and should not be shown to the user.
  const hasNewEntry = logs && logs.some(log => Number(log.logstatus) === 4);
  const filteredLogs = logs
    ? logs.filter(log => {
        if (hasNewEntry && Number(log.logstatus) === 1) {
          const desc = (log.description || '').trim().toLowerCase();
          return desc !== '' && desc !== 'status changed';
        }
        return true;
      })
    : [];

  return (
    <div 
      onClick={onClose}
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[200] p-4 animate-in fade-in duration-300"
    >
      <div 
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl w-full max-w-2xl max-h-[80vh] flex flex-col shadow-2xl overflow-hidden animate-in zoom-in-95 duration-300"
      >
        {/* Header */}
        <div className="p-4 border-b border-gray-100 flex items-center justify-between bg-gradient-to-r from-amber-50/50 to-transparent">
          <div>
            <h3 className="text-xl font-bold text-gray-900">Service Activity Logs</h3>
            <p className="text-sm text-gray-500 mt-1">
              History for <span className="font-semibold text-gray-700">{serviceName}</span> by <span className="font-semibold text-gray-700">{userName}</span>
            </p>
          </div>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-400 hover:text-gray-600"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          {isLoading ? (
            <div className="flex flex-col items-center justify-center py-20">
              <div className="w-10 h-10 border-4 border-amber-600 border-t-transparent rounded-full animate-spin"></div>
              <p className="mt-4 text-gray-500 font-medium">Fetching activity logs...</p>
            </div>
          ) : filteredLogs && filteredLogs.length > 0 ? (
            <div className="space-y-4">
              {filteredLogs.map((log, index) => (
                <div key={index} className="flex gap-4">
                  <div className="flex flex-col items-center">
                    <div className={`w-3 h-3 rounded-full mt-1.5 ring-4 ${getStatusDotClasses(log.logstatus)}`}></div>
                    {index !== filteredLogs.length - 1 && <div className="w-0.5 flex-1 bg-gray-100 my-1"></div>}
                  </div>
                  <div className="flex-1 pb-4">
                    <div className="flex items-center justify-between mb-1">
                      <span className={`px-2 py-0.5 rounded text-[10px] font-bold capitialize tracking-wider ${getStatusBadgeClasses(log.logstatus)}`}>
                        {getStatusText(log.logstatus)}
                      </span>
                      <span className="text-xs text-gray-400 font-medium">
                        {log.logcreatedon}
                      </span>
                    </div>
                  <p className="text-xs text-gray-600 leading-relaxed bg-gray-50 py-2 px-3 rounded-lg border border-gray-100">
  {log.description || 'Status changed'}
</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-20 text-gray-400">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="mb-4 opacity-20">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
              <p>No activity logs found for this service.</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-gray-100 bg-gray-50 flex justify-end">
          <button 
            onClick={onClose}
            className="px-6 py-2 bg-black  text-white rounded-xl text-sm font-semibold"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};